<template>
  <div class="invests__result">
    <div>Год: {{ item.period }}</div>
    <div>
      Стартовый баланс: {{ item.startAmount | number }}{{symbol}}
    </div>
    <div>
      Внесено: {{ item.contribution | number }}{{symbol}}
    </div>
    <div>
      Внесено всего: {{ item.totalContribution | number }}{{symbol}}
    </div>
    <div>
      Доход за период: {{ item.currentReturn | number }}{{symbol}}
    </div>
    <div>
      Суммарный доход: {{ item.totalReturn | number }}{{symbol}}
    </div>   
    <div>
      Итоговый баланс: {{ item.amount | number }}{{symbol}}
    </div>
  </div>
</template>

<script>
import {formatNumber, formatCurrencySymbol}
  from '../../filters/index.js';


export default {
  props: ['item'],
  computed: {
    symbol: function () {
      return formatCurrencySymbol(this.item.currency);
    }
  },
  filters: {
    number: formatNumber
  }
}
</script>